import { matchPath, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// ----------------------------------------------------------------------

type ReturnType = boolean;

export function useActiveLink(path: string, deep = true): ReturnType {
  const { pathname } = useLocation();
  const activeTabIndex = useSelector((state: any) => state.tabs.activeTabIndex);
  const mainTabs = useSelector((state: any) => state.tabs.mainTabs);

  if (activeTabIndex === -1 || mainTabs.length === 0) {
    return false;
  }

  const activeTab = mainTabs[activeTabIndex];
  const activePath = activeTab?.subTabs?.length > 0
    ? activeTab.subTabs[activeTab.activeSubTab || 0]?.path
    : activeTab?.path;


  const tabActive = activePath === path;
  
  return tabActive;
}
